<template>
<el-aside width="" :class="{'aside-close':isCollapse}">
	<div style="height:100%; overflow:auto" id="my-scrollbar" v-scrollbar>

		<div class="erp-logobox">
			<router-link to="/">
                <img v-if="isCollapse" src="/static/images/logo.png">
                <img src="/static/images/logotxt.png" v-if="!isCollapse">
			</router-link> 
		</div>
		<el-menu router :collapse="isCollapse" :default-active="currentRouter" :unique-opened="true" class="el-menu-vertical-demo" background-color="#2e4351" text-color="#BBCADC" active-text-color="#409FFD">	
			<!-- 动态绑定内容 -->
			<el-submenu :index="category.id" v-for="category in menu" :key="category.id">
				<template slot="title">
					<i class="el-icon-menu"></i>
					<span slot="title" class="nav-next asideClose-hidden">{{category.name}}</span>
				</template>

				<el-menu-item v-for="item in category.children" :index="item.router" :key="item.id" >
					<span class="asideClose-hidden" style="padding-left:24px;">{{item.name}}</span>
				</el-menu-item> 									            
			</el-submenu>

		</el-menu>

	</div>
</el-aside>
</template>

<script>
	export default {
		name: "Aside",
		components: {},
		props: ['isCollapse','menu'],
		data() {
			return {
				currentRouter: ''
			}
		},
		created:function(){
		},
		methods: {

		},
		watch:{
			 $route: {
			 	handler: function(){
			 		this.currentRouter = this.$route.path;
			 	},
			 	immediate: true
			 }
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}
	
	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	.el-submenu .el-menu-item {
		min-width: auto
	}
	
	.el-aside {
		background: #2e4351;
	}
	
	.el-aside.is-collapse {
		width: 64px;
	}
	
	
	/*解决折叠文字的样式问题*/
	
	.aside-close .asideClose-hidden {
		display: none;
	}
	
	.aside-close .el-submenu {
		height: 56px;
		overflow: hidden;
	}
	
	.el-aside .logo {
		width: 100%;
		height: 50px;
		overflow: hidden;
		position: relative;
	}
	.erp-logobox{ 
		height: 50px;
		text-align: center;
		/* position: relative; */
		width: 100%
	}
	/* .erp-logobox div{
		position: absolute;
		left: 0;
		top: 0;
		width: 100%
	} */
	.erp-logobox img{
		vertical-align: middle;
		padding:0;
	}
	
	
	.is-collapse {
		transform: rotate(90deg);
	}
	
	.el-menu {
		border: 0;
		background: #2e4351;
	}
	.el-submenu .el-menu-item{ background:#222f3e !important}	
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 180px;
	}
	.el-submenu .el-menu-item-group{		
		background: #273b49 !important;
	}

	.el-submenu [class^=el-icon-]{
		font-size: 12px;
		width: 20px;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue